import React, { useState } from 'react';
import Modal from './modal';

const emptyValue = (filter) => {
  if (filter === 'text') return '';
  if (filter === 'choice') return [];
  return ['', ''];
};

const RangeFields = ({ column, value, onChange, data }) => {
  const type = column.filter === 'date' ? 'date' : 'number';
  const [low, high] = value;
  const lowLabel = data.t.read(type === 'date' ? 'from' : 'expenses_accounts_list.minimum');
  const highLabel = data.t.read(type === 'date' ? 'to' : 'expenses_accounts_list.maximum');
  return (
    <div className="d-flex" style={{ gap: 12 }}>
      <label className="flex-fill">
        {lowLabel}
        <input className="form-control" type={type} step={type === 'number' ? '0.01' : undefined} value={low} onChange={(e) => onChange([e.target.value, high])} />
      </label>
      <label className="flex-fill">
        {highLabel}
        <input className="form-control" type={type} step={type === 'number' ? '0.01' : undefined} value={high} onChange={(e) => onChange([low, e.target.value])} />
      </label>
    </div>
  );
};

const Choices = ({ choices, value, onChange, data }) => (
  <div className="d-flex flex-column">
    {choices.map((choice) => (
      <label key={choice.value} className="mb-1">
        <input
          type="checkbox"
          className="mr-2"
          checked={value.includes(choice.value)}
          onChange={() => onChange(value.includes(choice.value) ? value.filter((v) => v !== choice.value) : [...value, choice.value])}
        />
        {data.t.read(choice.label)}
      </label>
    ))}
  </div>
);

/** Edits the filter of one column of the expense report list (XPEN-3788). */
const ExpensesAccountsFilterModal = ({ column, value, data, onApply, onCancel }) => {
  const [draft, setDraft] = useState(value ?? emptyValue(column.filter));
  const title = `${data.t.read('filter_by')} ${data.t.read(column.label)}`;
  return (
    <Modal
      title={title}
      cancelAction={onCancel}
      cancelText={data.t.read('cancel')}
      secondaryAction={() => onApply(emptyValue(column.filter))}
      secondaryText={data.t.read('expenses_accounts_list.clear')}
      okAction={() => onApply(draft)}
      okText={data.t.read('filter')}
    >
      {column.filter === 'text' && (
        <label className="w-100">
          {data.t.read('expenses_accounts_list.contains')}
          <input className="form-control" autoFocus value={draft} onChange={(e) => setDraft(e.target.value)} />
        </label>
      )}
      {column.filter === 'choice' && <Choices choices={column.choices} value={draft} onChange={setDraft} data={data} />}
      {(column.filter === 'date' || column.filter === 'number') && <RangeFields column={column} value={draft} onChange={setDraft} data={data} />}
    </Modal>
  );
};

export default ExpensesAccountsFilterModal;
